module.exports = __webpack_public_path__ + "img/hand.7bef9af7.svg";